<template>
  <div class="join-personal-data">
    <v-row>
      <v-col class="join-personal-data__form-col">

        <PrimaryInformationsForm
          v-if="currentState === 1"
          @submit="submitStep"
        />

        <EmploymentDetailsForm
          v-if="currentState === 2"
          @submit="submitStep"
        />

        <AdditionalInformationsForm
          v-if="currentState === 3"
          @submit="submitForms"
        />

      </v-col>
      <v-col>

        <StepSlider/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import StepSlider from '@/components/Developer/Join/StepSlider.vue';
import PrimaryInformationsForm from '@/components/Developer/Join/Form/PrimaryInformationsForm.vue';
import EmploymentDetailsForm from '@/components/Developer/Join/Form/EmploymentDetailsForm.vue';
import AdditionalInformationsForm from '@/components/Developer/Join/Form/AdditionalInformationsForm.vue';

export default {
  components: {
    StepSlider,
    PrimaryInformationsForm,
    EmploymentDetailsForm,
    AdditionalInformationsForm,
  },

  props: {
    processing: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      currentState: 1,
      isSubmitProcessing: false,
    };
  },

  computed: {
    ...mapState('developer', ['developer']),
  },

  methods: {
    ...mapActions('developer', [
      'updateDeveloper',
    ]),

    submitStep() {
      this.currentState += 1;
    },

    submitForms() {
      this.isSubmitProcessing = true;

      this.updateDeveloper(this.developer)
        .then(() => {
          this.$emit('submit', 3);
        })
        .finally(() => {
          this.isSubmitProcessing = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .join-developer {
  margin-top: 12px;
    &__form-label {
      font-size: 12px;
      font-weight: 600;
      padding-bottom: 8px;
      margin-bottom: 16px;
      margin-top: 10px;
      border-bottom: 1px solid #E2E6EA;
    }

    &__form-col {
      @include desktop {
        padding-right: 80px;
      }
    }

    &__row {
      margin-right: -8px;
      margin-left: -8px;
    }

    &__col {
      padding: 0 8px 8px;
    }

    &__btn {
      margin-top: 88px;
    }
  }
</style>
